// test1279
(1279 && 0);
